import React, { useState } from 'react'; 
import {
  AppBar,
  Box,
  Stack,
  Toolbar,
  IconButton,
  TextField,
  InputAdornment,
  Typography
} from '@mui/material';
import {
  Menu as MenuIcon,
  Fullscreen as FullscreenIcon,
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu';
import { useOrganizations } from '../../customHooks';

export const Navbar = ({
  showSideBarOption,
  handleSidebarOpen,
  mode,
  toggleMode
}) => {
  const navigate = useNavigate();
  const { organization } = useOrganizations();

  const [searchOptions, setSearchOptions] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(console.error);
    } else {
      document.exitFullscreen();
    }
  };

  // flattening logic unchanged…
  const flattenedOptions = organization?.flatMap(cat =>
    cat.options.flatMap(opt => [
      { label: opt.Label, to: opt.to || '', id: opt.id.trim() },
      ...(opt.menu?.flatMap(menu => [
        { label: menu.Label, to: menu.to || '', id: menu.id.trim() },
        ...(menu.children?.map(c => ({ label: c.Label, to: c.to || '', id: c.id.trim() })) || [])
      ]) || [])
    ])
  ) || [];

  const handleInputChange = (_, value) => {
    if (value?.length >= 3) {
      setSearchOptions(flattenedOptions.filter(o =>
        o.label.toLowerCase().includes(value.toLowerCase())
      ));
    } else {
      setSearchOptions([]);
    }
  };

  return (
    <AppBar
      component="nav"
      position="static"
      sx={{
        boxShadow: 'none',
        height: '60px',
        background: mode === 'dark'
          ? '#252b3b'
          : 'linear-gradient(to right, #2d9CDB 0%, #0b1d51 100%)',
        zIndex: 1000,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', height: '70px' }}>
        {showSideBarOption && (
          <IconButton onClick={handleSidebarOpen} sx={{ color: 'white' }}>
            <MenuIcon fontSize="large" />
          </IconButton>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Stack direction="row" spacing={1} alignItems="center">

            <Box textAlign="center">
              <IconButton onClick={toggleFullscreen} sx={{ color: 'white' }}>
                <FullscreenIcon />
              </IconButton>

              {/* Commented out the "Full Screen" text — only the icon is shown now */}
              {/*
              <Typography variant="caption" sx={{ color: 'white', mt: -1 }}>
                Full Screen
              </Typography>
              */}
            </Box>

            {/* <Box textAlign="center">
            <IconButton onClick={toggleMode} sx={{ color: 'white' }}>
  {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
</IconButton>

              <Typography variant="caption" sx={{ color: 'white', mt: -1 }}>
                {mode === 'dark' ? 'Light' : 'Dark'}
              </Typography>
            </Box> */}

            {/* <IconButton color="inherit">
              <NotificationDropdown />
            </IconButton> */}

            {/* 
              We want only the avatar to show (no username text). 
              The ProfileMenu component is left intact, but wrapped in a container that hides
              likely username elements (common selectors). This preserves the dropdown functionality
              while showing only the picture. If ProfileMenu uses different internal classNames,
              you can update the selectors below inside sx.
            */}
            <Box
              sx={{
                // attempt to hide name/label inside ProfileMenu while keeping avatar & dropdown
                '& .profile-name': { display: 'none !important' }, // common custom class
                '& .MuiTypography-root': { display: 'none !important' }, // MUI typography inside
                '& .username': { display: 'none !important' }, // alternate common class
                // ensure avatar (img or avatar) remains visible
                '& img, & .MuiAvatar-root, & svg': { display: 'inline-block !important' },
              }}
            >
              <ProfileMenu />
            </Box>

          </Stack>
        </Box>
      </Toolbar>

      {isSearchOpen && (
        <Box
          sx={{
            width: '100%',
            position: 'absolute',
            top: 70,
            left: 0,
            right: 0,
            backgroundColor: mode === 'dark' ? '#252b3b' : 'white',
            p: 4,
          }}
        >
          <TextField
            fullWidth
            placeholder="Search..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={e => handleInputChange(e, e.target.value)}
          />
        </Box>
      )}
    </AppBar>
  );
};
